<template>
  <section class="bd-content" ref="vidOuter">
    <template v-if="fileReady">
      <template v-if="hasStreamServer">
        <template>
          <video
            v-if="isIOS"
            ref="vde"
            id="vde"
            width="100%"
            controls
            controlslist="nodownload"
            :autoplay="showPlayerControls"
            :seekable="false"
          >
            <source
              v-if="file.ext === 'mp4'"
              :src="file.link"
              type="video/mp4"
            />
            Your browser does not support HTML5 video.
          </video>
          <div v-else class="pos-relative">
            <video
              :id="`video_hls_plyr_${fileId}`"
              :controls="true"
              :style="`width: 100%; height: calc(100vh - ${vidSize.height}px)`"
            ></video>
          </div>
        </template>
      </template>
      <template v-else>
        <video width="100%" controls controlslist="nodownload" autoplay>
          <source
            v-if="file.ext === 'mp4'"
            :src="playerLink"
            type="video/mp4"
          />
          Your browser does not support HTML5 video.
        </video>
        <!-- <video :id="`video_hls_plyr_${fileId}`" controls="true" :style="`width: 100%; height: calc(100vh - ${vidSize.height}px)`"></video> -->
      </template>

      <b-modal
        v-model="questObj.modal"
        centered
        title="Асуулт"
        @hide="onHideQuestion"
        hide-header-close
        no-close-on-backdrop
      >
        <template v-if="questObj.modal && questObj.obj != null">
          <div class="bd-b pd-y-10 mg-b-10">
            <div v-html="questObj.obj.s1"></div>
            <div v-html="questObj.obj.info"></div>
          </div>
          <div>
            <div
              @click="submitQuestion(questObj.obj, a)"
              v-for="(a, ai) in questObj.obj.a"
              :key="ai"
              :class="`d-flex ${getColor(questObj.obj, a)}`"
              role="button"
            >
              <div class="pd-r-5">{{ alphabetize(ai) }}.</div>
              <div class="pd-x-5">
                <i :class="`far fa-${getIcon(questObj.obj, a)}`"></i>

                <!-- <i v-if="questObj.obj.t==3" :class="`far fa-${a.isFilled ? 'check-square' : 'square'}`"></i>
                <i v-else-if="questObj.obj.t==4 && a.b1==100" :class="`far fa-${a.isFilled  ? 'check-circle' : 'circle'}`"></i>
                <i v-else-if="questObj.obj.t==4 && a.b1!=100" :class="`far fa-${a.isFilled  ? 'check-circle' : 'circle'}`"></i> -->
              </div>
              <div v-html="a.s1"></div>
            </div>
          </div>
        </template>
        <!-- {{questObj.obj}} -->
        <template #modal-footer>
          <div class="mg-l-auto">
            <b-button @click="onCloseQuestion" variant="danger">Хаах</b-button>
          </div>
        </template>
      </b-modal>

      <b-overlay :show="openContinue" no-wrap>
        <template #overlay>
          <div
            ref="dialog"
            tabindex="-1"
            role="dialog"
            aria-modal="false"
            aria-labelledby="form-confirm-label"
            class="text-center p-3"
          >
            <p>
              <strong id="form-confirm-label"
                >Видеог дуусгаагүй орхисон байна. <br />Үргэлжлүүлэн тоглуулах
                уу ?</strong
              >
            </p>
            <div class="">
              <b-button
                @click="reStartPlayer()"
                variant="outline-primary"
                class="mr-2"
                >Үгүй</b-button
              >
              <b-button
                @click="
                  openContinue = false;
                  playerResume();
                "
                variant="primary"
                >Тийм</b-button
              >
            </div>
          </div>
        </template>
      </b-overlay>

      <b-overlay :show="openContinue2" no-wrap>
        <template #overlay>
          <div
            ref="dialog"
            tabindex="-1"
            role="dialog"
            aria-modal="false"
            aria-labelledby="form-confirm-label"
            class="text-center p-3"
          >
            <feather
              @click="playerResume2()"
              type="youtube"
              style="width: 128px; height: 128px; color: #009ca2"
              role="button"
            ></feather>
            <!-- <p>
                <strong id="form-confirm-label">Видеог дуусгаагүй орхисон байна. <br />Үргэлжлүүлэн тоглуулах уу ?</strong>
              </p>
              <div class="">
                <b-button @click="openContinue2 = false"
                  variant="outline-primary"
                  class="mr-2" >Үгүй</b-button
                >
                <b-button @click="openContinue2 = false; playerResume()"
                  variant="primary"
                  >Тийм</b-button
                >
              </div> -->
          </div>
        </template>
      </b-overlay>
    </template>
  </section>
</template>
<script>
import { fileInheritedDetail } from "@/api/media";
import Hls from "hls.js";
import dashjs from "dashjs";
// import { isMobile } from 'mobile-device-detect';
var player;
import { request } from "@/api/all";
import { hasOneOf, alphabetize } from "@/libs/tools";
import { Notification } from "element-ui";
//import ControlBar from '@/assets/js/ControlBar'

var videoplr;
//var intrvl;

import { mapActions } from "vuex";

export default {
  components: {
    Notification, //videoPlayer
  },
  name: "videoPreview",
  props: {
    propFileId: {
      type: Number,
      default: () => null,
    },
    prms: {
      type: Object,
      default: () => {},
    },
    minusHeight: {
      type: Number,
      default: () => 115,
    },
  },
  data() {
    return {
      hasHlsServer: false,
      fullViewCount: 0,
      intrvl: null,
      showPlayerControls: true,
      showPlayerControlsHtml: false,
      cdnBaseUrl: "https://cdn.gosmart.mn/",
      currentTime: 0,
      openContinue: false,
      openContinue2: false,
      playerLink: "",
      streamBaseUrl: "",
      hasStreamServer: true,
      playerReady: false,
      isIOS: false,
      fileReady: false,
      file: {},
      deletingFileId: 0,
      vidUrl: "",

      playerOptions: {
        // videojs options
        //muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            //withCredentials: false,
            type: "application/x-mpegURL",
            //type: "video/mp4",
            src: "",
          },
        ],
        poster: "/static/images/author.jpg",
      },
      destroyed: false,
      fileId: 0,
      vidSize: {
        width: 0,
        // height: 250,
        height: 250,
      },

      interactiveObj: {
        formId: null,
        questions: [],
        interactives: [],
      },

      questObj: {
        backOnClose: false,
        real: null,
        obj: null,
        modal: false,
      },
      viewLog: {
        second: 0,
      },
      isDestroyed: false,
    };
  },
  beforeDestroy() {
    this.isDestroyed = true;

    //console.log('before destroy fired');
    request({
      api: { method: "POST", url: "Media/UpdateVideoViewLog" },
      data: {
        attachId: this.fileId,
        logId: this.viewLog.id,
        second: this.currentTime,
        isFullView: false,
      },
      store: this.$store,
    }).then((res) => {
      if (res != false) {
        //console.log('UpdateVideoViewLog', res);

        this.destroyed = true;
        if (this.playerReady) {
          this.playerPause();
          // Destroy player instance if it exists (HLS or DASH)
          if (player && typeof player.destroy === "function") {
            player.destroy();
          } else if (player && typeof player.reset === "function") {
            // DASH player uses reset() method
            player.reset();
          }
        }
        this.fileReady = false;
      }
    });
    //Object.assign(this.$data, this.$options.data());

    if (this.isIOS) {
      //console.log('videoplr', videoplr);

      videoplr.removeEventListener("seeking", (event) => {
        self.htmlSeek(event);
      });
      videoplr.removeEventListener("playing", (event) => {
        self.htmlPlay(event);
      });
      videoplr.removeEventListener("ended", (event) => {
        self.htmlEnded(event);
      });

      videoplr = null;

      //clearTimeout(this.intrvl);
      clearInterval(this.intrvl);
      //this.intrvl= null;

      Object.assign(this.$data, this.$options.data());
    }
  },
  mounted() {
    //console.log('this is current player instance object', this.player)
    //this.handleLoading({ isLoading: true });
    this.configure();
    this.init();
  },
  // computed: {
  // },
  methods: {
    ...mapActions(["handleLoading"]),
    configure() {
      if (
        this.$store.state.app.activeGroup.hasStreamServer != undefined &&
        !this.$store.state.app.activeGroup.hasStreamServer
      ) {
        //console.log('this.hasStreamServer false setlev');
        this.hasStreamServer = false;
      }

      if (
        this.$store.state.app.activeGroup.streamBaseUrl != undefined &&
        this.$store.state.app.activeGroup.streamBaseUrl != ""
      ) {
        this.streamBaseUrl = this.$store.state.app.activeGroup.streamBaseUrl;
      }

      if (
        this.$store.state.app.activeGroup.cdnBaseUrl != undefined &&
        this.$store.state.app.activeGroup.cdnBaseUrl != ""
      ) {
        this.cdnBaseUrl = this.$store.state.app.activeGroup.cdnBaseUrl;
      }

      if (
        this.$store.state.app.activeGroup.hasHlsServer != undefined &&
        this.$store.state.app.activeGroup.hasHlsServer
      ) {
        this.hasHlsServer = true;
      }
    },
    init() {
      let self = this;
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }
      this.fileId = _id;
      this.$nextTick(() => {
        self.fetchPlayer(_id);
      });
    },
    fileAfter() {
      // this.vidSize= {
      //   width: 640,
      //   height: 480
      // };
      //console.log("this.$refs.vidOuter.clientHeight", this.$refs.vidOuter.clientHeight);
    },
    fetchAfter(aid, b1) {
      //console.log('fetchAfte', aid, b1);
      let self = this;
      //this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "Media/GetLastVideoViewLog" },
        data: {
          attachId: aid,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          if (this.isIOS) {
            //const videoplr = this.$refs.vde;
            videoplr = this.$refs.vde;
            //console.log(videoplr.duration);
            if (b1) {
              videoplr.addEventListener("seeking", (event) => {
                self.htmlSeek(event);
              });
            }

            videoplr.addEventListener("playing", (event) => {
              self.htmlPlay(event);
            });
            videoplr.addEventListener("ended", (event) => {
              self.htmlEnded(event);
            });
          }

          if (res.data.fullViewCount !== undefined) {
            this.fullViewCount = res.data.fullViewCount;
          }
          this.viewLog = res.data.viewLog;
          //let _pv=localStorage.getItem(`vr_${this.fileId}`);

          // if(_pv!=undefined && parseInt(_pv, 10)>0){
          //   //console.log('fetchAfter step 1');
          //   this.currentTime=parseInt(_pv, 10);

          //   setTimeout(() => {
          //     if (!self.destroyed) {
          //       if(self.isIOS){
          //         videoplr.currentTime= self.currentTime;
          //       } else {
          //         self.playerSeek(self.currentTime);
          //       }
          //       self.openContinue= true;
          //       //self.handleLoading({ isLoading: false });
          //       //self.playerReady = true;
          //     }
          //   }, 1000);
          // } else
          //console.log('fetchAfter step 2', this.viewLog.second);
          if (parseInt(this.viewLog.second, 10) > 0) {
            setTimeout(() => {
              if (!self.destroyed) {
                if (self.isIOS) {
                  videoplr.currentTime = this.viewLog.second;
                } else {
                  self.playerSeek(this.viewLog.second);
                }
                self.openContinue = true;
                //self.handleLoading({ isLoading: false });
                //self.playerReady = true;
              }
            }, 1000);
          } else {
            //console.log('step 3');
            //if(!self.openContinue){
            //setTimeout(() => {
            //console.log('sett time out ajiljinu', self.destroyed);
            //self.playerReady = true;

            //if (!self.destroyed) {
            //self.playerResume();
            //console.log('plr resme ddudsnnnn');
            //}
            //self.handleLoading({ isLoading: false });
            //self.playerReady = true;
            if (!this.isIOS) this.openContinue2 = true;
            //}, 0);
            //}else{
            //self.handleLoading({ isLoading: false });
            //self.playerReady = true;
            //}
            //self.handleLoading({ isLoading: false });
          }
        } else {
          //this.handleLoading({ isLoading: false });
        }
      });
    },
    fetchInteractives(aid) {
      let self = this;

      //this.playerReady= false;
      request({
        api: { method: "GET", url: "Media/GetInteractiveOption" },
        params: {
          id: aid,
          boxId: this.$route.params.bid,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          //console.log('GetInteractiveOption=> ', res);
          this.interactiveObj.interactives = res.data.config.interactives.filter(
            (x) => !x.isDone,
          );

          if (
            this.isIOS &&
            this.interactiveObj.interactives.filter(
              (x) => x.second > 0 && !x.isShow,
            ).length > 0
          ) {
            //if(thi)
            this.$bvToast.toast(
              "Интерактив тохиргоотой видео байна. Бүрэн үзэхийг хүсвэл компьютер-с хандана уу",
              {
                title: "Мэдэгдэл",
                autoHideDelay: 5000,
                appendToast: false,
                variant: "warning",
                toaster: "b-toaster-bottom-right",
              },
            );
          }

          if (res.data.config.hasForm) {
            this.fetchInteractiveForm(res.data.config.formId);
          }

          if (res.data.config.b1 != undefined && res.data.config.b1) {
            this.showPlayerControls = false;
            //console.log('step 98');
            this.$emit("on-hide-finish-btn");

            //this.fetchAfter(aid);
          }
          // else{
          //   this.playerResume();
          // }
          this.fetchAfter(aid, res.data.config.b1);

          //setTimeout(() => {
          //self.playerReady= true;
          //}, 10000);
          //this.playerReady= true;
        } else {
          //this.playerReady= true;
        }
      });
    },
    fetchInteractiveForm(formId) {
      this.interactiveObj.formId = formId;
      request({
        api: { method: "GET", url: "Form/GetLatestResponse" },
        params: {
          form: formId,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          //console.log('Form/GetLatestResponse=> ', res.data.questions.filter(x=>x.t==3 || x.t==4));

          // if(hasOneOf(this.interactiveObj.interactives.map(x=> { return x.objectId }), [parseInt(e.time, 10)])){

          // }
          //# TODO
          //console.log('ugluu endees ehlene');
          //this.interactiveObj.questions= res.data.questions.filter(x=>(x.t==3 || x.t==4) && hasOneOf(this.interactiveObj.interactives.map(x=> { return x.objectId }) ,[x.id]) );
          //console.log('this.interactiveObj.questions', res.data.questions.filter(x=>(x.t==3 || x.t==4)).length, this.interactiveObj.questions);
          this.interactiveObj.questions = res.data.questions;
        }
      });
    },
    convertMp4ToHls(mp4Url) {
      const url = new URL(mp4Url);

      // path-ийг folder болон filename гэж задална
      const parts = url.pathname.split("/");

      // Эцсийн файл (videoName.mp4)
      const filename = parts.pop();

      // filename-ээс mp4-г m3u8 болгоно
      const hlsFilename = filename.replace(/\.mp4$/i, ".m3u8");

      // hls folder-ийг filename-ийн өмнө нэмнэ
      parts.push("hls", hlsFilename);

      // URL path-г шинэчилнэ
      url.pathname = parts.join("/");

      return url.toString();
    },

    convertMp4ToDash(mp4Url) {
      // Replace CDN URL with stream server URL for DASH
      return (
        mp4Url.replace(
          this.cdnBaseUrl,
          this.streamBaseUrl + "VOD-TEST/_definst_/mp4:"
        ) + "/manifest.mpd"
      );
    },

    fetchPlayer(_id) {
      //console.log('fetchPlayer', _id);
      let self = this;
      //this.handleLoading({ isLoading: true });

      fileInheritedDetail({ params: { id: _id }, store: this.$store }).then(
        (res) => {
          //this.handleLoading({ isLoading: false });

          if (res != false) {
            if (!this.destroyed) {
              this.fileReady = true;
              this.file = res.data.file;

              //this.fileAfter();

              // if(this.$store.state.app.activeGroup.id==9245){
              //   this.isIOS = true;
              // }else{

              // }

              //#GOTODO
              //# 2022.10.18 halamjtai holbootoi commentlov ios video garaagui
              // if(!this.hasStreamServer){
              //   this.isIOS = true;
              //   this.hasStreamServer= true;
              // }

              if (!this.hasStreamServer) {
                //# disable stream server
                this.playerLink = res.data.file.link;
              } else {
                this.$nextTick(() => {
                  var video;
                  var url;
                  
                  video = document.getElementById("video_hls_plyr_" + _id);
                  
                  if (!this.hasHlsServer) {
                    //# Use DASH player when HLS server is disabled
                    // Convert MP4 URL to MPD (DASH manifest)
                    url = this.convertMp4ToDash(res.data.file.link);

                    player = dashjs.MediaPlayer().create();
                    player.initialize(video, url, false);

                    // Setup event listeners for DASH
                    video.addEventListener("timeupdate", function () {
                      self.onProgress({ time: video.currentTime });
                    });

                    video.addEventListener("play", function () {
                      self.onStarted();
                    });

                    video.addEventListener("ended", function () {
                      self.onEnded();
                    });

                    video.addEventListener("seeking", function () {
                      self.onSeeking();
                    });

                    video.addEventListener("seeked", function () {
                      self.onSeeked();
                    });

                    player.on(dashjs.MediaPlayer.events.ERROR, function (e) {
                      console.error("DASH player error:", e);
                    });

                    var userAgent = window.navigator.userAgent;
                    console.log('userAgent', userAgent);
                    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
                      this.isIOS = true;
                      url =
                        res.data.file.link.replace(
                          self.cdnBaseUrl,
                          self.streamBaseUrl + "VOD-TEST/_definst_/mp4:"
                        ) + "/playlist.m3u8";
                    }
                  } else {
                    //# Use HLS format
                    url = this.convertMp4ToHls(res.data.file.link);

                    // Check if HLS is supported
                    if (Hls.isSupported()) {
                      player = new Hls({
                        enableWorker: true,
                        lowLatencyMode: false
                      });

                      player.loadSource(url);
                      player.attachMedia(video);

                      player.on(Hls.Events.MANIFEST_PARSED, function () {
                        //console.log('HLS manifest loaded');
                      });

                      player.on(Hls.Events.ERROR, function (event, data) {
                        if (data.fatal) {
                          switch (data.type) {
                            case Hls.ErrorTypes.NETWORK_ERROR:
                              //console.error('Network error');
                              player.startLoad();
                              break;
                            case Hls.ErrorTypes.MEDIA_ERROR:
                              //console.error('Media error');
                              player.recoverMediaError();
                              break;
                            default:
                              //console.error('Fatal error, cannot recover');
                              player.destroy();
                              break;
                          }
                        }
                      });

                      // Setup event listeners
                      video.addEventListener("timeupdate", function () {
                        self.onProgress({ time: video.currentTime });
                      });

                      video.addEventListener("play", function () {
                        self.onStarted();
                      });

                      video.addEventListener("ended", function () {
                        self.onEnded();
                      });

                      video.addEventListener("seeking", function () {
                        self.onSeeking();
                      });

                      video.addEventListener("seeked", function () {
                        self.onSeeked();
                      });
                    } else if (
                      video.canPlayType("application/vnd.apple.mpegurl")
                    ) {
                      // Native HLS support (Safari, iOS)
                      this.isIOS = true;
                      this.file.link = url;
                      video.src = url;

                      video.addEventListener("timeupdate", function () {
                        self.onProgress({ time: video.currentTime });
                      });

                      video.addEventListener("play", function () {
                        self.onStarted();
                      });

                      video.addEventListener("ended", function () {
                        self.onEnded();
                      });

                      video.addEventListener("seeking", function () {
                        self.onSeeking();
                      });

                      video.addEventListener("seeked", function () {
                        self.onSeeked();
                      });
                    }
                  }

                  this.fetchInteractives(_id);
                });
              }
            } else {
              this.playerPause();
              //console.log("destroyed after inizil");
            }
          }
        },
      );
    },
    onStarted() {
      let self = this;
      clearInterval(this.intrvl);

      //this.openContinue2= false;

      this.intrvl = setInterval(function() {
        if (self.isDestroyed) {
          clearInterval(self.intrvl);
        } else {
          const video = document.getElementById(`video_hls_plyr_${self.fileId}`);
          if (video) {
            self.currentTime = video.currentTime;
            localStorage.setItem(`vr_${self.fileId}`, self.currentTime);
          }
        }
      }, 1000);
    },
    onSeeking() {
      // console.log('sdf', this.viewLog)
      if (this.fullViewCount > 0) {
        return true;
      }
      
      const video = document.getElementById(`video_hls_plyr_${this.fileId}`);
      if (!video) return;
      
      const videoTime = video.currentTime;
      //console.log('onSeeking', videoTime, this.currentTime, 'nuhtsul ni => ', (videoTime > this.currentTime && !this.showPlayerControls));
      //console.log('plr rdy', this.playerReady, this.openContinue2);

      //if(!this.openContinue2){
      if (
        videoTime > this.currentTime &&
        this.currentTime > 0 &&
        !this.showPlayerControls
      ) {
        //console.log('onseeking step 1');
        video.currentTime = this.currentTime;

        Notification({
          title: "Санамж",
          message: "Видеог гүйлгэхгүй үзэж дуусгах тохиргоотой байна !",
          position: "bottom-right",
        });
      } else {
        this.currentTime = videoTime;
      }
      //}
      // else{
      //   this.openContinue2= false;
      //   video.currentTime = this.currentTime;

      //   Notification({
      //     title: 'Санамж',
      //     message: 'Видеог гүйлгэхгүй үзэж дуусгах тохиргоотой байна !',
      //     position: 'bottom-right'
      //   });
      // }
    },
    onSeeked() {
      //console.log('onSeeked 3');
    },
    zaOdoo(e) {
      //this.handleLoading({ isLoading: false });
      //console.log('za odoo', e);
    },
    onProgress(e) {
      if (this.openContinue2 && e.time > 0.1) {
        //console.log('endees vv', e.time);
        this.openContinue2 = false;
      }

      //console.log('onProgress', parseInt(e.time, 10));
      if (
        parseInt(e.time, 10) > 0 &&
        hasOneOf(
          this.interactiveObj.interactives
            .filter((x) => !x.isShow)
            .map((x) => {
              return x.second;
            }),
          [parseInt(e.time, 10)],
        )
      ) {
        //console.log('sec is ', e, this.interactiveObj.interactives);

        let _intrs = this.interactiveObj.interactives.filter(
          (x) => x.second == parseInt(e.time, 10),
        );
        if (_intrs.length > 0) {
          let _int = _intrs[0];

          if (
            _int.type == 1 &&
            this.interactiveObj.questions.filter(
              (x) => (x.t == 3 || x.t == 4) && x.id == _int.objectId,
            ).length > 0
          ) {
            //console.log(this.interactiveObj.questions.filter(x=> (x.t == 3 || x.t == 4) && x.id==_int.objectId));
            //this.interactiveObj.questions.filter(x=>x.t== (3 || 4) && x.id==_int.objectId).length>0
            this.showQuestion(_int);
            _int.isShow = true;
            this.playerPause();
          } else if (_int.type == 2) {
            this.showInteractiveMedia(_int);
            _int.isShow = true;
            this.playerPause();
          } else if (_int.type == 3) {
            this.showInteractiveHtml(_int);
            _int.isShow = true;
            this.playerPause();
          }
        }
      }
      //console.log('onProgress ', parseInt(e.time, 10));
    },
    showQuestion(obj) {
      if (
        this.interactiveObj.questions.filter((x) => x.id == obj.objectId)
          .length > 0
      ) {
        this.questObj.real = obj;
        this.questObj.obj = this.interactiveObj.questions.filter(
          (x) => x.id == obj.objectId,
        )[0];
        this.questObj.modal = true;
      }
    },
    showInteractiveMedia(obj) {
      this.$emit("on-interactive-media", obj.objectId);
      this.showInteractiveDone(obj);
    },
    showInteractiveHtml(obj) {
      this.$emit("on-interactive-html", obj.description);
      //this.showInteractiveDone(obj);
    },

    showInteractiveDone(obj) {
      //console.log('showInteractiveAfter', obj);
      request({
        api: { method: "POST", url: "Media/InteractiveObjectDone" },
        data: {
          attachId: this.fileId,
          objectId: obj.objectId,
          type: obj.type,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
        }
      });
    },

    onEnded() {
      request({
        api: { method: "POST", url: "Media/UpdateVideoViewLog" },
        data: {
          attachId: this.fileId,
          logId: this.viewLog.id,
          second: this.currentTime,
          isFullView: true,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          //console.log('this.interactiveObj.interactives', this.interactiveObj.interactives);
          if (
            this.interactiveObj.interactives.filter(
              (x) => x.second > 0 && !x.isShow,
            ).length > 0
          ) {
            this.playerSeek(0);

            //if(thi)
            this.$bvToast.toast(
              "Видеог гүйлгэхгүйгээр бүрэн үзэж дуусгана уу",
              {
                title: "Мэдэгдэл",
                autoHideDelay: 5000,
                appendToast: false,
                variant: "warning",
                toaster: "b-toaster-bottom-right",
              },
            );
          } else {
            this.currentTime = 0;
            localStorage.removeItem(`vr_${this.fileId}`);
            this.$emit("on-finish-video", this.propFileId);
          }
        }
      });
    },
    reStartPlayer() {
      if (this.isIOS) {
        videoplr.currentTime = 0;
      } else {
        this.playerSeek(0);
        this.openContinue2 = true;
        request({
          api: { method: "POST", url: "Media/UpdateVideoViewLog" },
          data: {
            attachId: this.fileId,
            logId: this.viewLog.id,
            second: 0,
            isFullView: false,
          },
          store: this.$store,
        });
      }
      this.currentTime = 0;
      this.openContinue = false;
      localStorage.removeItem(`vr_${this.fileId}`);
    },
    playerResume2() {
      //console.log(player);
      this.playerResume();
    },
    playerResume() {
      let self = this;
      //console.log('player resume fired');
      if (this.isIOS) {
        videoplr.play();
      } else {
        const video = document.getElementById(`video_hls_plyr_${this.fileId}`);
        if (video) {
          try {
            video.play();
          } catch {}
        }
      }
    },
    playerPause() {
      const video = document.getElementById(`video_hls_plyr_${this.fileId}`);
      if (video) {
        try {
          video.pause();
        } catch {}
      }
    },
    playerSeek(s) {
      const video = document.getElementById(`video_hls_plyr_${this.fileId}`);
      if (video) {
        try {
          video.currentTime = s;
        } catch {}
      }
      //console.log('playerBack', s, video);
    },
    alphabetize(v) {
      return alphabetize(v);
    },
    getIcon(q, a) {
      let rv = null;
      if (q.isFilled && a.isFilled) {
        if (q.t == 4) {
          if (a.b1 == 100) {
            rv = "check-circle";
          } else {
            rv = "question-circle";
          }
        } else if (q.t == 3) {
          if (a.b1 == 100) {
            rv = "check-square";
          } else {
            rv = "minus-square";
          }
        }
      } else {
        if (q.t == 4) {
          rv = "circle";
        } else if (q.t == 3) {
          rv = "square";
        }
      }
      return rv;
    },
    getColor(q, a) {
      let rv = null;
      if (q.isFilled) {
        if (a.isFilled && a.b1 == 100) {
          rv = "text-success";
        } else if (a.isFilled) {
          rv = "text-primary";
        }

        // if(a.isFilled && a.b1==100){
        //   rv= 'text-success';
        // } else if(a.isFilled && a.b1!=100){
        //   rv= 'text-warning';
        // } else if(!a.isFilled && a.b1==100){
        //   rv= 'text-success';
        // }
      }
      //console.log(q);
      //if()
      return rv;
    },
    onCloseQuestion() {
      // if(this.questObj.modal && this.questObj.obj!=null){
      //   console.log(this.interactiveObj.questions);
      // }
      if (this.questObj.backOnClose) {
        this.questObj.real = null;
        this.questObj.obj = null;
        this.questObj.modal = false;
        this.playerResume();
      }
    },
    onHideQuestion() {
      //console.log('onHideQuestion', this.questObj.backOnClose);
      if (this.questObj.backOnClose) {
        // //console.log('playerSeek', this.interactiveObj.interactives.filter(x=>x.objectId==this.questObj.obj.id));
        // let _iitn= this.interactiveObj.interactives.filter(x=>x.objectId==this.questObj.obj.id);
        // if(_iitn.length>0){
        //   this.playerSeek(_iitn[0].backSecond);
        // }
      } else {
        this.questObj.real = null;
        this.questObj.obj = null;
        this.questObj.modal = false;
        this.playerResume();
      }
    },
    submitQuestion(q, a, str, isForce) {
      //console.log(this.id, q, a)
      let _data = {
        formId: this.interactiveObj.formId,
        questionId: q.id,
        answerId: a.id,
        str: str,
        checkFlag: 1,
      };
      //console.log('this.questObj.real', this.questObj.real);
      //formId: 16472
      //questionId: 181556
      //answerId: 341495

      if (q.t == 3 || q.t == 4) {
        request({
          api: { method: "POST", url: "Form/CheckQuestion" },
          params: _data,
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            if (q.t == 3 || q.t == 4) {
              if (q.t == 4 || q.t == 23) {
                if (a.b1 != 100) {
                  this.$bvToast.toast("Буруу хариулсан", {
                    title: "Мэдэгдэл",
                    autoHideDelay: 5000,
                    appendToast: false,
                    variant: "warning",
                    toaster: "b-toaster-bottom-right",
                  });
                  if (this.questObj.real.isBack) {
                    //this.questObj.backOnClose= false;
                    this.interactiveObj.interactives.filter(
                      (x) => x.objectId == this.questObj.real.objectId,
                    )[0]["isShow"] = false;
                    this.playerSeek(this.questObj.real.backSecond);
                  }
                  //this.onHideQuestion();
                } else {
                  this.$bvToast.toast("Зөв хариулсан", {
                    title: "Мэдэгдэл",
                    autoHideDelay: 5000,
                    appendToast: false,
                    variant: "success",
                    toaster: "b-toaster-bottom-right",
                  });
                  //this.questObj.backOnClose= true;
                }

                //console.log('zuv buruu halin ve', a, this.questObj.backOnClose);

                q.a.forEach((e) => {
                  e.str = e.id == a.id ? e.str : "";
                  e.isFilled = e.id == a.id;
                });

                this.questObj.backOnClose = true;
              } else if (q.t == 3 || q.t == 24) {
                a.isFilled = !a.isFilled;
                if (a.b1 == 100) {
                  this.$bvToast.toast("Зөв хариулсан", {
                    title: "Мэдэгдэл",
                    autoHideDelay: 5000,
                    appendToast: false,
                    variant: "success",
                    toaster: "b-toaster-bottom-right",
                  });
                } else {
                  if (this.questObj.real.isBack) {
                    //this.questObj.backOnClose= false;
                    this.interactiveObj.interactives.filter(
                      (x) => x.objectId == this.questObj.real.objectId,
                    )[0]["isShow"] = false;
                    this.playerSeek(this.questObj.real.backSecond);
                  }
                  this.$bvToast.toast("Буруу хариулсан", {
                    title: "Мэдэгдэл",
                    autoHideDelay: 5000,
                    appendToast: false,
                    variant: "warning",
                    toaster: "b-toaster-bottom-right",
                  });
                }

                this.questObj.backOnClose = true;
              } else {
                if (str == undefined) {
                  a.str = "";
                  a.isFilled = !a.isFilled;
                }

                this.questObj.backOnClose = true;
              }

              q.isFilled = q.a.filter((x) => x.isFilled).length > 0;
            }

            // if(a.isFilled && a.b1==100){
            //   //console.log('zuv hariulsan bol done duudnaa', a)
            //  //this.showInteractiveDone(this.questObj.real);
            // }
          }
        });
      }
    },
    htmlPlay(e) {
      //console.log('htmlPlay fireeeeeeeeeeeeed');

      clearInterval(this.intrvl);
      let self = this;

      this.intrvl = setInterval(function() {
        let _tme = parseInt(videoplr.currentTime, 10);

        if (self.isDestroyed) {
          clearInterval(self.intrvl);
        } else {
          self.currentTime = _tme;
          localStorage.setItem(`vr_${self.fileId}`, self.currentTime);
        }
      }, 1000);
    },
    htmlSeek(e) {
      let _tme = parseInt(videoplr.currentTime, 10);
      //if(this.playerReady){
      //if(_tme > this.currentTime && this.currentTime>0 && !this.showPlayerControls) {
      if (
        _tme > this.currentTime &&
        this.currentTime > 0 &&
        !this.showPlayerControlsHtml
      ) {
        videoplr.currentTime = this.currentTime;
        Notification({
          title: "Санамж",
          message: "Видеог гүйлгэхгүй үзэж дуусгах тохиргоотой байна !",
          position: "bottom-right",
        });
      } else {
        this.currentTime = _tme;
      }
      // }else{
      //   videoplr.currentTime= this.currentTime;
      //   Notification({
      //     title: 'Санамж',
      //     message: 'Видеог гүйлгэхгүй үзэж дуусгах тохиргоотой байна !',
      //     position: 'bottom-right'
      //   });
      // }
    },
    htmlEnded(e) {
      this.onEnded();
    },
  },
};
</script>
